import { Navigate, useLocation } from 'react-router-dom';

// This route predates the PayFast fee-calculation flow (superseded by PaymentConfirmation.tsx
// in March 2026, before this app ever went live) and used to build its own PayFast redirect
// without ever calculating the transaction fee. It's kept only as a redirect in case a stale
// link to it ever surfaces, so it can never again send anyone to PayFast without the fee applied.
export default function PaymentRedirect() {
  const location = useLocation();
  return <Navigate to={`/payment/confirmation${location.search}`} replace />;
}
